import styled from "styled-components";

export const EventCard = styled.div`
    height: 100%;
    //margin: 0 auto;
    position: relative;
    transition: all 0.3s ease-out;
 box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); 
 //border-radius:10px;
    @media(hover: hover) {
        &:not(.is-today):hover,
        &:not(.is-upcoming):hover {
            cursor: pointer !important;
            pointer-events: all !important;
            transition: all 0.3s ease-out;
            
        }

        &:hover .event-button {
            background-color: rgba(255,255,255, 1) !important;
            transition: all 0.3s ease-out;
        }
    }

    &.is-upcoming {
        cursor: default;
        pointer-events: none;

        &.is-private {
            cursor: pointer;
            pointer-events: all;
            transition: all 0.3s ease-out;
            width: 100%;
        }
    }

     .event-button {
        transition: all 0.3s ease-out;
    }
`;

export const EventCardBodyWrapper = styled.div<{ backgroundImageUrl?: string }>`
    height: 176px;
    padding: 20px;
    width: 100%;
    align-items: center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${props => props.backgroundImageUrl ? props.backgroundImageUrl : ''});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 1s ease-in-out;
`;

export const Title = styled.div`
    font-size: 18px !important;
    font-weight: 700 !important;
    color: rgb(255, 255, 255) !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    margin-bottom: 8px !important;
    overflow: hidden !important;
    display: -webkit-box !important;
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
`;

export const Type = styled.span`
    margin-top: 20px;
    background: rgba(204,204,204, 1);
    padding: 5px 20px;
    display: inline-block;

    &.private,
    &.live {
        background: #DC3545;
        color: rgba(255,255,255, 1);
    }
`;

export const Logo = styled.img`
    width: 80px;
    height: 80px;
    object-fit: contain;
    object-position: 50% 50%;
    position: relative;
`;

export const EventCardDetailWrapper = styled.div`
    height: 70px;
    background: rgba(11,11,11, 1);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    // border-bottom-left-radius:10px;
    // border-bottom-right-radius:10px;
`;

export const EventDateWrapper = styled.div`
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: rgba(255,255,255, 1);
    margin: 0;
`;

export const Divider = styled.div`
    height: 10px;
    background: linear-gradient(to right bottom, rgba(184,249,79, 1), rgba(11,11,11, 1));
`;

export const PrivatePlanLabel = styled.span`
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255, 1);
    line-height: 1.25;
`;